export const environment = {
  production: true,
   //base_url: 'http://localhost:3001/back',
   //base_url: 'https://dev-kite-back.j14host.com/back',
   //base_url: 'https://kite-pro-back-e4bc948c89cf.herokuapp.com/back',
  base_url: 'https://kite-pro.com/back-dev',
  //base_url: 'https://kite-pro-back-e4bc948c89cf.herokuapp.com/back',
  apiZapier: 'https://hooks.zapier.com/hooks/catch/11934680/bih759g/',
  apiPabbly: 'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjMwNTY1MDYzMDA0MzE1MjY1NTUzMSI_3D_pc'
};
